import { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  paperClasses,
} from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import moment from 'moment';
import { useAttendance } from 'providers/AttendanceContext';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useSettingsContext } from 'providers/SettingsProvider';
import { topnavVibrantStyle } from 'theme/styles/vibrantNav';
import IconifyIcon from 'components/base/IconifyIcon';
import Logo from 'components/common/Logo';
import VibrantBackground from 'components/common/VibrantBackground';
import AppbarActionItems from '../common/AppbarActionItems';

// import SearchBox, { SearchBoxButton } from '../common/search-box/SearchBox';

const AppBar = () => {
  const { isClockedIn, punchIn, punchOut, activeShift, loading } = useAttendance();
  const [open, setOpen] = useState(false);
  const [func, setFunc] = useState(null);
  const handleClose = () => {
    setOpen(false);
    if (func == 'punchIn') {
      punchIn();
    } else if (func == 'punchOut') {
      punchOut();
    }
    setFunc(null);
  };
  const {
    config: { drawerWidth, sidenavType, navColor },
    handleDrawerToggle,
  } = useSettingsContext();

  const { up } = useBreakpoints();
  const upSm = up('sm');
  const upMd = up('md');

  const prevSidenavTypeRef = useRef(sidenavType);

  useEffect(() => {
    if (prevSidenavTypeRef.current !== sidenavType) {
      prevSidenavTypeRef.current = sidenavType;
    }
  }, [sidenavType]);

  return (
    <MuiAppBar
      position="fixed"
      sx={[
        {
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          borderBottom: `1px solid`,
          borderColor: 'divider',
          [`&.${paperClasses.root}`]: {
            outline: 'none',
          },
        },
        sidenavType === 'stacked' &&
          sidenavType === prevSidenavTypeRef.current &&
          ((theme) => ({
            transition: theme.transitions.create(['width'], {
              duration: theme.transitions.duration.standard,
            }),
          })),
        navColor === 'vibrant' && !upMd && topnavVibrantStyle,
      ]}
    >
      {navColor === 'vibrant' && !upMd && <VibrantBackground position="top" />}
      <Toolbar variant="appbar" sx={{ px: { xs: 3, md: 5 } }}>
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            gap: 1,
            pr: 2,
          }}
        >
          <Button
            color="neutral"
            variant="soft"
            shape="circle"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <IconifyIcon icon="material-symbols:menu-rounded" sx={{ fontSize: 20 }} />
          </Button>

          <Box>
            <Logo showName={upSm} />
          </Box>
        </Box>

        <Stack
          sx={{
            alignItems: 'center',
            flex: 1,
          }}
        >
          {/* {upMd ? (
            <SearchBox
              sx={{
                width: 1,
                maxWidth: 420,
              }}
            />
          ) : (
            <SearchBoxButton />
          )} */}

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            alignItems={{ xs: 'stretch', sm: 'center' }}
          >
            {upSm ? (
              !isClockedIn ? (
                <>
                  {' '}
                  {activeShift && (
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                      {activeShift.logoutTime
                        ? `punchIn - ${moment(activeShift.loginTime).format('DD/MM/YYYY HH:mm A')}
                         - punchOut - ${moment(activeShift.logoutTime).format('DD/MM/YYYY HH:mm A')}`
                        : `punchIn - ${moment(activeShift.loginTime).format('DD/MM/YYYY HH:mm A')}`}
                    </Typography>
                  )}
                  {!activeShift && (
                    <Button
                      variant="contained"
                      color="success"
                      disabled={isClockedIn || activeShift}
                      loading={loading}
                      onClick={() => {
                        setOpen(true);
                        setFunc('punchIn');
                      }}
                    >
                      Punch In
                    </Button>
                  )}
                </>
              ) : (
                <>
                  {activeShift && (
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                      {activeShift.logoutTime
                        ? `punchOut - ${moment(activeShift.logoutTime).format('DD/MM/YYYY HH:mm A')}`
                        : `punchIn - ${moment(activeShift.loginTime).format('DD/MM/YYYY HH:mm A')}`}
                    </Typography>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!isClockedIn}
                    loading={loading}
                    onClick={() => {
                      setOpen(true);
                      setFunc('punchOut');
                    }}
                  >
                    Punch Out
                  </Button>
                </>
              )
            ) : null}
            <Dialog
              open={open}
              onClose={handleClose}
              fullWidth={'md'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{'Are you sure?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are You Sure You want to {func}.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpen(false);
                    setFunc(null);
                  }}
                >
                  No
                </Button>
                <Button onClick={handleClose} autoFocus>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
          </Stack>
          <AppbarActionItems />
        </Stack>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
